import type App from './App';

import { createContext, useContext } from 'react';

export const AppContext: React.Context<App> = createContext<App>(undefined!);

AppContext.displayName = 'AppContext';

export function useApp<T>(): T & Omit<App, keyof T> {
    return useContext(AppContext) as T & App;
}